// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MemberLeads_member_lead_table_container__k-bFe {
  width: 100%;
  /* max-width: 1200px; */
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

/* Table Styling */
.MemberLeads_member_lead_table__ry4L9 {
  width: 100%;
  border-collapse: collapse;
}

.MemberLeads_member_lead_table__ry4L9 th,
.MemberLeads_member_lead_table__ry4L9 td {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: center;
}

.MemberLeads_member_lead_table__ry4L9 th {
  background: #007bff;
  color: white;
  font-weight: bold;
}

.MemberLeads_no_data__s2yWH {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #888;
}

/* Pagination */
.MemberLeads_pagination__njcBT {
  margin-top: 20px;
  text-align: center;
}

.MemberLeads_pagination__njcBT button {
  margin: 5px;
  padding: 10px 15px;
  border: none;
  background: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}

.MemberLeads_pagination__njcBT .MemberLeads_disabledButton__U3rNX {
  background: #ccc;
  cursor: not-allowed;
}

.MemberLeads_pagination__njcBT .MemberLeads_activePage__aCWmU {
  background: #0056b3;
  font-weight: bold;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .MemberLeads_member_lead_table_container__k-bFe {
    width: 95%;
    padding: 15px;
  }

  .MemberLeads_member_lead_table__ry4L9 th,
  .MemberLeads_member_lead_table__ry4L9 td {
    padding: 10px;
    font-size: 14px;
  }

  .MemberLeads_pagination__njcBT button {
    padding: 8px 12px;
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .MemberLeads_table_wrapper__RCfRT {
    overflow-x: auto;
  }

  .MemberLeads_member_lead_table__ry4L9 th,
  .MemberLeads_member_lead_table__ry4L9 td {
    padding: 8px;
    font-size: 12px;
  }

  .MemberLeads_pagination__njcBT button {
    padding: 6px 10px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .MemberLeads_member_lead_table_container__k-bFe {
    width: 100%;
    padding: 10px;
    box-shadow: none;
  }

  .MemberLeads_member_lead_table__ry4L9 th,
  .MemberLeads_member_lead_table__ry4L9 td {
    padding: 6px;
    font-size: 11px;
  }

  .MemberLeads_pagination__njcBT button {
    padding: 5px 8px;
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/MemberLeads.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".member_lead_table_container {\n  width: 100%;\n  /* max-width: 1200px; */\n  margin: 20px auto;\n  padding: 20px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n/* Table Styling */\n.member_lead_table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.member_lead_table th,\n.member_lead_table td {\n  padding: 12px;\n  border: 1px solid #ddd;\n  text-align: center;\n}\n\n.member_lead_table th {\n  background: #007bff;\n  color: white;\n  font-weight: bold;\n}\n\n.no_data {\n  text-align: center;\n  padding: 20px;\n  font-size: 16px;\n  color: #888;\n}\n\n/* Pagination */\n.pagination {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.pagination button {\n  margin: 5px;\n  padding: 10px 15px;\n  border: none;\n  background: #007bff;\n  color: white;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.pagination .disabledButton {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.pagination .activePage {\n  background: #0056b3;\n  font-weight: bold;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .member_lead_table_container {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .member_lead_table th,\n  .member_lead_table td {\n    padding: 10px;\n    font-size: 14px;\n  }\n\n  .pagination button {\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .table_wrapper {\n    overflow-x: auto;\n  }\n\n  .member_lead_table th,\n  .member_lead_table td {\n    padding: 8px;\n    font-size: 12px;\n  }\n\n  .pagination button {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .member_lead_table_container {\n    width: 100%;\n    padding: 10px;\n    box-shadow: none;\n  }\n\n  .member_lead_table th,\n  .member_lead_table td {\n    padding: 6px;\n    font-size: 11px;\n  }\n\n  .pagination button {\n    padding: 5px 8px;\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"member_lead_table_container": `MemberLeads_member_lead_table_container__k-bFe`,
	"member_lead_table": `MemberLeads_member_lead_table__ry4L9`,
	"no_data": `MemberLeads_no_data__s2yWH`,
	"pagination": `MemberLeads_pagination__njcBT`,
	"disabledButton": `MemberLeads_disabledButton__U3rNX`,
	"activePage": `MemberLeads_activePage__aCWmU`,
	"table_wrapper": `MemberLeads_table_wrapper__RCfRT`
};
export default ___CSS_LOADER_EXPORT___;
